import BaseApiService from './BaseApiService'

class FeatureFlagApiService extends BaseApiService {
  getFeatureFlags(): Promise<Record<string, boolean>> {
    return this.post<Record<string, boolean>>('/v1/feature-flags/get')
  }

  getFeatureFlag(flagName: string): Promise<{ flagName: string; enabled: boolean }> {
    return this.post<{ flagName: string; enabled: boolean }>('/v1/feature-flags/get-flag', { flagName })
  }
}

export const featureFlagApiService = new FeatureFlagApiService()
